/**
/**
 * Pre-login password hashing for arcano.app
 * This code is under copyright Arcano Gmbh (https://arcano.app).
 *
 * - no commercial use
 * - no modifications
 * - no redistribution
 *
 * without written consent of Arcano Gmbh, zentralstrasse 47, 8003 zürich, switzerland, https://arcano.app
 */
'use strict';


import {
    delay,
    getIndexedDB,
    readCookie,
    setItem,
    setupPasswordEye,
    showErrorsOnForm,
    showHideFormErrors
} from "./utils";
import {addNewUser, getSecretKey, sendEditedFormData} from "./crypto";


export function setupRegisterUser() {
    const registerForm = document.getElementById('register')
    if (!registerForm) {
        return
    }
    registerUser()
}

function registerUser() {
    setupPasswordEye()

    const username = document.getElementById('username') as HTMLInputElement;
    const password = document.getElementById('password') as HTMLInputElement;
    const spam = document.getElementById('spam') as HTMLInputElement;

    const submit = document.getElementById('submit_button')!;
    const readConditions = document.getElementById('accept_agbs') as HTMLInputElement;
    const form = document.getElementById('register') as HTMLFormElement;

    username.addEventListener('keyup', delay(() => {
        showHideFormErrors(username)
    }, 300))
    password.addEventListener('keyup', delay(() => {
        showHideFormErrors(password)
    }, 300))

    form.addEventListener('change', () => {

        showHideFormErrors(username)
        showHideFormErrors(password)

        const ready = password.value && password.validity.valid && username.value && username.validity.valid && spam.value && readConditions.checked;

        if (ready) {
            submit.removeAttribute('disabled')
        } else {
            submit.setAttribute('disabled', '1')
        }
    })

    if (form) {
        form.addEventListener('submit', (event) => {
            event.preventDefault();
            submit.setAttribute('disabled', '1')

            const password = document.getElementById('password') as HTMLInputElement;

            if (password.value) {

                fetch('/pre_login/' + username.value)
                    .then((response) => response.json())
                    .then(result => {
                        if (result.hkdfSalt || result.scryptSalt) {
                            showErrorsOnForm('{"username" :["User already exists"]}')
                            return
                        }

                        addNewUser(password.value).then(userResult => {
                            const ref = readCookie('ref')
                            let data = new FormData(form);
                            data.set("password", undefined);
                            data.set("public_key", userResult.publicKey);
                            data.set("encrypted_private_key", (new Uint8Array(userResult.privateKey)).toString());
                            data.set("iv", userResult.iv.toString());
                            data.set("salt", userResult.salt.toString());
                            data.set("hkdf_salt", userResult.hkdfSalt);
                            data.set("scrypt_salt", userResult.scryptSalt);
                            data.set("scrypt_hashed_password", userResult.scryptHashedPassword);
                            data.set("reference", ref);
                            const urlParams = new URLSearchParams(document.location.search)
                            if(urlParams.get('buy')) {
                                data.set("buy", "true");
                            }
                            sendEditedFormData(form.action, data, 'POST', (request, response) => {
                                if (request.status === 400) {
                                    showErrorsOnForm(response.response);
                                    submit.removeAttribute('disabled');
                                }
                                if (request.status === 401) {
                                    showErrorsOnForm(response.response);
                                    submit.removeAttribute('disabled');
                                    // showFlash("Invalid user or password or 2FA (if enabled)", 'info')
                                }
                                if (request.status === 200 || request.status === 201) {
                                    const r = JSON.parse(response.response)
                                    getSecretKey(password.value).then((unwrappedKey) => {
                                        const dbsuccess = (event: any) => {
                                            const onerror = () => {
                                                window.location.href = '/';
                                            }
                                            const oncomplete = () => {
                                                window.location.href = r.url
                                            }

                                            let db = event.target.result;

                                            setItem(db, 'key', unwrappedKey, oncomplete, onerror);
                                        }
                                        const dbfail = () => {
                                            // ok we have no indexedDB, it should not matter...
                                            window.location.href = r.url;  // get logged in anyway
                                        }
                                        getIndexedDB(dbsuccess, dbfail);
                                    })
                                } else {
                                    showErrorsOnForm(response.response);
                                    submit.removeAttribute('disabled');
                                }
                            });
                        })
                    })
            } else {
                console.debug('Nevermind');
            }
        });
    }
}






